import { Link } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import MobileMenu from '../../components/feature/MobileMenu';
import { useSEO } from '../../hooks/useSEO';
import JsonLd from '../../components/feature/JsonLd';

const allCaseStudies = [
  { id: 1, title: 'Designing patient first clinical trials through a patient app', client: 'Global pharmaceutical company', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/ee9b8a579b0f0dfe46dd47075426190b.jpeg', link: '/work/chiesi-patient-first-clinical-trials' },
  { id: 7, title: 'Revitalising mental health in Hong Kong through AR & AI', client: 'Google', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/983b2cf2226e0ba05a8262de5bbfcb7c.jpeg', link: '/work/google-ar-mental-health' },
  { id: 2, title: 'Using patient archetypes to shape clinical development', client: 'Global pharmaceutical company', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/6c69339dc5a77859d2a0cfae4ed16ef8.jpeg', link: '/work/chiesi-patient-archetypes' },
  { id: 18, title: 'Improving the experience of women fleeing domestic violence', client: 'The Good Samaritan Inn & Victorian Government', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/a8131d8083980545235293ed39dce142.jpeg', link: '/work/good-samaritan-inn-domestic-violence' },
  { id: 5, title: 'Reimagining how crucial vaccines are brought to market', client: 'Top 10 Pharmaceutical Company', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/59ca997d5d37a61c379ae60ca4f40e99.jpeg', link: '/work/astrazeneca-vaccines' },
  { id: 14, title: "Changing the way tourists visit the world's largest coral reef", client: 'Tourism Tropical North Queensland', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/63681d5d3cbfa151a1002be71469addf.jpeg', link: '/work/tourism-tropical-north-queensland' },
  { id: 6, title: "Ending the world's oldest and deadliest disease", client: 'Malaria No More', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/a06f54a857c41d4cbe8f3fb37f4f8f71.jpeg', link: '/work/malaria-no-more' },
  { id: 10, title: 'Transforming the patient care experience across every phase', client: 'ConvaTec', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/7267f85f5ccc07f058256cd1cf369acd.jpeg', link: '/work/convatec-patient-care' },
  { id: 8, title: 'Getting life saving plasma to those who need it most', client: 'Australian Red Cross Blood Service', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/6ebaadf85ce4b26263f432cd39d36f8d.jpeg', link: '/work/australian-red-cross-plasma' },
  { id: 13, title: 'Supporting families navigate cancer treatment and the journey home', client: 'Camp Quality', image: 'https://public.readdy.ai/ai/img_res/edited_08dcfee1391436c0d865020a4f9fe88b_585d55ce.jpg', link: '/work/camp-quality-new-normal-navigator' },
  { id: 3, title: 'Creating a patient experience framework to set the foundations for change', client: 'Global pharmaceutical company', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/e7148a0e3de63bc88e3e7e813263df57.jpeg', link: '/work/chiesi-patient-experience-framework' },
  { id: 4, title: 'Transforming how patient insights are gathered, stored and used', client: 'Global pharmaceutical company', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/403472c7ae6592343ba0e169a5753aee.jpeg', link: '/work/gsk-viiv-patient-insights' },
  { id: 11, title: 'Helping chronically ill teenagers transition to better health care', client: 'Monash Hospital', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/3225b8391bf9aaae4aff6a1a542fc2cf.jpeg', link: '/work/monash-hospital-teenagers' },
  { id: 9, title: 'Improving liver cancer treatment for patients & doctors', client: 'Top 10 Pharmaceutical Company', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/d654018d15e7499296428d0262ccfb1e.jpeg', link: '/work/astrazeneca-liver-cancer' },
  { id: 12, title: 'Changing the way communities access health care and visit their doctor', client: 'East Brunswick Medical Centre', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/65e4b3a231f765d88a983851ba9becb4.jpeg', link: '/work/east-brunswick-medical-centre' },
  { id: 21, title: 'Transforming child care services for all Australians', client: 'Australian Government — Digital Transformation Agency', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/539c84e5a4ad46a9781e879fecfb040d.jpeg', link: '/work/australian-government-child-care' },
  { id: 15, title: "Creating an innovation toolkit for the UN's 2030 Sustainability Agenda", client: 'United Nations', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/7a741e0401ad7f2e45c8e5ee74bd16e4.jpeg', link: '/work/united-nations-innovation-toolkit' },
  { id: 16, title: "Creating a lighter environmental footprint with Australia's biggest airline", client: 'QANTAS Airlines', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/4ad0a90dbe5e416105555825b8b1142f.jpeg', link: '/work/qantas-sustainability' },
  { id: 17, title: 'Tackling disadvantage in schools to support vulnerable kids', client: 'Adobe, Swinburne University & Victorian Government', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/53f7ea1a2396188884d51729562c5e8f.jpeg', link: '/work/adobe-swinburne-vulnerable-kids' },
  { id: 19, title: 'Reimagining funding strategies for communities in need', client: 'World Vision', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/034e87d049dfecb8cebff17f0d1e9b5f.jpeg', link: '/work/world-vision-funding-strategies' },
  { id: 20, title: 'Helping grassroots organisations support refugees', client: 'For Refugees', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/09217488e3035e03e862d2bfec2f6873.jpeg', link: '/work/for-refugees' },
  { id: 24, title: 'Improving customer journeys during flight delays', client: 'Jetstar Airlines', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/9e02e6ffe00a1d7c89715bb190f7985c.png', link: '/work/jetstar-flight-delays' },
  { id: 23, title: 'Building customer experience capability at scale', client: 'ANZ Bank', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/c1355d6782632938a4e39b50fda48bd4.png', link: '/work/anz-bank-customer-experience' },
  { id: 25, title: 'Reframing digital growth around priority customer segments', client: 'Merlin Entertainments', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/53703d9b542b2cc694ffe0ba633452a9.jpeg', link: '/work/merlin-entertainments-digital-growth' },
  { id: 22, title: 'Designing a creative learning program for budding entrepreneurs', client: 'RMIT University — Activator Programme', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/d76f4c5f0a9e9e5255110e1cf8965722.jpeg', link: '/work/rmit-activator' },
  { id: 27, title: 'Transforming the painters ecosystem across digital & retail', client: 'Dulux', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/806b5990f6b8f076533cd25370c837a9.jpeg', link: '/work/dulux-painters-ecosystem' },
  { id: 31, title: 'An innovation lab to change how people work, learn, and collaborate', client: 'Australia Post', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/d2f9a300d0cb70229fc5583fc06613aa.jpeg', link: '/work/australia-post-innovation-lab' },
  { id: 30, title: 'Making it easier to send something overseas', client: 'Australia Post', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/2440086bf223f5f29bf2e8753a78aaad.jpeg', link: '/work/australia-post-international-posting' },
  { id: 26, title: 'Shifting beauty from transactions to empowerment through digital', client: 'Shiseido', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/28ae7bf51bb22294b27f1d1328abb261.jpeg', link: '/work/shiseido-beauty-empowerment' },
  { id: 28, title: 'Transforming how Australia Post empowers retail teams', client: 'Australia Post', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/f51239612ad3261deef39b206f89a51a.jpeg', link: '/work/australia-post-retail-teams' },
  { id: 29, title: 'Changing history — how mail is delivered across Australia', client: 'Australia Post', image: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/c5c40e9e56cca8dda124b128f6d36169.jpeg', link: '/work/australia-post-mail-delivery' },
];

function CaseStudyCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const autoPlayRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = allCaseStudies.length;

  useEffect(() => {
    const updateVisibleCount = () => {
      setVisibleCount(window.innerWidth < 768 ? 1 : 3);
    };
    updateVisibleCount();
    window.addEventListener('resize', updateVisibleCount);
    return () => window.removeEventListener('resize', updateVisibleCount);
  }, []);

  const startAutoPlay = () => {
    autoPlayRef.current = setInterval(() => {
      goNext();
    }, 8000);
  };

  const stopAutoPlay = () => {
    if (autoPlayRef.current) clearInterval(autoPlayRef.current);
  };

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, [currentIndex]);

  const goNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + visibleCount) % total);
      setIsTransitioning(false);
    }, 700);
  };

  const goPrev = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - visibleCount + total) % total);
      setIsTransitioning(false);
    }, 700);
  };

  const getVisibleStudies = () => {
    const items = [];
    for (let i = 0; i < visibleCount; i++) {
      items.push(allCaseStudies[(currentIndex + i) % total]);
    }
    return items;
  };

  const visibleStudies = getVisibleStudies();

  return (
    <div
      className="relative"
      onMouseEnter={stopAutoPlay}
      onMouseLeave={startAutoPlay}
    >
      {/* Cards */}
      <div
        className="grid grid-cols-1 md:grid-cols-3 gap-6 transition-opacity duration-700"
        style={{ opacity: isTransitioning ? 0 : 1 }}
      >
        {visibleStudies.map((study) => (
          <Link
            key={`${study.id}-${currentIndex}`}
            to={study.link}
            className="group cursor-pointer"
          >
            <div className="relative h-72 overflow-hidden mb-5 rounded-xl">
              <img
                src={study.image}
                alt={study.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="space-y-2">
              <p className="text-xs uppercase tracking-wider text-primary font-bold">{study.client}</p>
              <h3 className="text-xl font-black text-black group-hover:text-primary transition-colors duration-700 leading-snug line-clamp-3">
                {study.title}
              </h3>
            </div>
          </Link>
        ))}
      </div>

      {/* Controls */}
      <div className="flex items-center justify-end mt-10">
        {/* Prev / Next */}
        <div className="flex gap-3">
          <button
            onClick={() => { stopAutoPlay(); goPrev(); }}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 hover:border-primary hover:text-primary transition-all duration-700 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
          </button>
          <button
            onClick={() => { stopAutoPlay(); goNext(); }}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 hover:border-primary hover:text-primary transition-all duration-700 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default function HomePage() {
  useSEO({
    title: 'Design For',
    description: 'Human-centred strategy, experience design & innovation.',
    keywords: 'human-centred design, design thinking, innovation consultancy, healthcare design, government services, social impact, user experience, service design',
    canonical: '/',
    ogType: 'website',
    ogImage: 'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/73aab30a8e0b42ae25f8a6c0be2fa56a.jpeg'
  });

  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [wordIndex, setWordIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [nextImageIndex, setNextImageIndex] = useState(1);
  const [imageTransitioning, setImageTransitioning] = useState(false);

  const cyclingWords = ['humanity', 'growth', 'the future', 'good', 'business', 'impact'];

  const heroImages = [
    // humanity
    'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/e7148a0e3de63bc88e3e7e813263df57.jpeg',
    // growth
    'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/53f7ea1a2396188884d51729562c5e8f.jpeg',
    // the future
    'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/1138b949a8b22455b4e65d42e4ac2d26.jpeg',
    // good
    'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/5969660c4240c353f782bfaedd6513ee.jpeg',
    // business
    'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/a8131d8083980545235293ed39dce142.jpeg',
    // impact
    'https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/034e87d049dfecb8cebff17f0d1e9b5f.jpeg',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      const next = (wordIndex + 1) % cyclingWords.length;
      setNextImageIndex(next);
      setAnimating(true);
      setImageTransitioning(true);
      setTimeout(() => {
        setWordIndex(next);
        setImageIndex(next);
        setAnimating(false);
        setTimeout(() => {
          setImageTransitioning(false);
        }, 700);
      }, 400);
    }, 2200);
    return () => clearInterval(interval);
  }, [wordIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <JsonLd data={[
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Design For",
          "url": "https://example.com",
          "description": "Human-centred design consultancy specializing in healthcare, government, and social impact",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://example.com/work?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        },
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Design For",
          "url": "https://example.com",
          "logo": "https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/511aeba7affe24966a38635cdd087c13.png",
          "description": "Award-winning human-centred design consultancy specializing in healthcare, government, and social impact",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "London",
            "addressCountry": "GB"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "hello@designfor.uk",
            "contactType": "Customer Service"
          },
          "sameAs": [
            "https://www.linkedin.com/in/kara-prosser-26960977/"
          ]
        }
      ]} />
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-24">
            <Link to="/" className="flex items-center">
              <img 
                src={scrolled 
                  ? "https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/511aeba7affe24966a38635cdd087c13.png"
                  : "https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/177dc540d7c9a6700435609d623348f7.png"
                }
                alt="Design For" 
                className="h-16"
              />
            </Link>
            <div className="hidden md:flex items-center space-x-10">
              <Link to="/" className={`${scrolled ? 'text-black' : 'text-white'} hover:text-primary transition-colors duration-200 text-sm font-medium uppercase tracking-wider`}>Home</Link>
              <Link to="/about" className={`${scrolled ? 'text-black' : 'text-white'} hover:text-primary transition-colors duration-200 text-sm font-medium uppercase tracking-wider`}>About</Link>
              <Link to="/services" className={`${scrolled ? 'text-black' : 'text-white'} hover:text-primary transition-colors duration-200 text-sm font-medium uppercase tracking-wider`}>Services</Link>
              <Link to="/work" className={`${scrolled ? 'text-black' : 'text-white'} hover:text-primary transition-colors duration-200 text-sm font-medium uppercase tracking-wider`}>Work</Link>
              <Link to="/resources" className={`${scrolled ? 'text-black' : 'text-white'} hover:text-[#ff4858] transition-colors duration-200 text-sm font-medium uppercase tracking-wider`}>Insights</Link>
              <Link to="/contact" className="bg-primary text-white px-6 py-3 rounded-full hover:bg-primary/90 transition-all duration-200 text-sm font-bold uppercase tracking-wider whitespace-nowrap">
                Contact
              </Link>
            </div>
            <button 
              onClick={() => setMobileMenuOpen(true)}
              className={`md:hidden ${scrolled ? 'text-black' : 'text-white'}`}
            >
              <i className="ri-menu-line text-3xl"></i>
            </button>
          </div>
        </div>
      </nav>

      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      {/* Hero Section with Background Image */}
      <section className="min-h-screen flex items-center relative overflow-hidden">
        {/* Background Images — crossfade */}
        {heroImages.map((src, i) => (
          <div
            key={i}
            className="absolute inset-0 z-0 transition-opacity duration-700"
            style={{ opacity: i === imageIndex ? 1 : i === nextImageIndex && imageTransitioning ? 1 : 0 }}
          >
            <img
              src={src}
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
        ))}
        {/* Overlay */}
        <div
          className="absolute inset-0 z-[1] transition-all duration-700"
          style={{
            background: imageIndex === 3
              ? 'linear-gradient(to bottom, rgba(0,0,0,0.65), rgba(0,0,0,0.55), rgba(0,0,0,0.65))'
              : 'linear-gradient(to bottom, rgba(0,0,0,0.40), rgba(0,0,0,0.30), rgba(0,0,0,0.40))'
          }}
        ></div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-32">
          <div className="max-w-4xl">
            <div className="space-y-8">
              <h1 className="text-7xl lg:text-8xl font-black text-white leading-[1.1] tracking-tight">
                design for{' '}
                <span
                  className="font-normal inline-block transition-all duration-400"
                  style={{
                    opacity: animating ? 0 : 1,
                    transform: animating ? 'translateY(12px)' : 'translateY(0)',
                    transition: 'opacity 0.4s ease, transform 0.4s ease',
                  }}
                >
                  {cyclingWords[wordIndex]}
                </span>
              </h1>
              <p className="text-2xl lg:text-3xl text-white font-medium leading-relaxed max-w-3xl">
                We partner with ambitious organisations to design better products, services and experiences, and future proof their business for what's next.
              </p>
              <div className="pt-4">
                <Link to="/contact" className="inline-flex items-center gap-3 bg-primary text-white px-10 py-5 rounded-full hover:bg-primary/90 transition-all duration-300 text-base font-bold uppercase tracking-wider whitespace-nowrap group">
                  Get Started
                  <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="py-28 bg-[#f8f8f8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-6">
              <p className="text-sm font-black text-primary uppercase tracking-wider">What we do</p>
              <h2 className="text-5xl lg:text-6xl font-black text-black tracking-tight leading-[1.05]">
                Design that drives real change
              </h2>
              <p className="text-lg text-gray-600 font-medium leading-relaxed">
                We work at the intersection of strategy, experience design and capability building — helping ambitious organisations solve complex challenges and create lasting impact.
              </p>
              <Link to="/services" className="inline-flex items-center gap-3 bg-primary text-white px-8 py-4 rounded-full hover:bg-primary/90 transition-all duration-300 text-sm font-bold uppercase tracking-wider whitespace-nowrap group">
                Explore Our Services
                <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 gap-4">
              <Link to="/services#strategy" className="bg-white rounded-2xl p-7 flex items-start gap-5 hover:shadow-md transition-all duration-300 cursor-pointer group">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-primary/10 rounded-xl">
                  <i className="ri-line-chart-line text-primary text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-black text-black mb-1 group-hover:text-primary transition-colors">Strategy</h3>
                  <p className="text-sm text-gray-500 font-medium leading-relaxed">Creating clarity on where you're going, how you'll grow, and what will set you apart.</p>
                </div>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-line text-primary text-lg"></i>
                </div>
              </Link>

              <Link to="/services#experience-design" className="bg-white rounded-2xl p-7 flex items-start gap-5 hover:shadow-md transition-all duration-300 cursor-pointer group">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-primary/10 rounded-xl">
                  <i className="ri-team-line text-primary text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-black text-black mb-1 group-hover:text-primary transition-colors">Experience Design</h3>
                  <p className="text-sm text-gray-500 font-medium leading-relaxed">Designing future-ready experiences that feel intuitive, connected and built around real human needs.</p>
                </div>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-line text-primary text-lg"></i>
                </div>
              </Link>

              <Link to="/services#building-ideas" className="bg-white rounded-2xl p-7 flex items-start gap-5 hover:shadow-md transition-all duration-300 cursor-pointer group">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-primary/10 rounded-xl">
                  <i className="ri-lightbulb-flash-line text-primary text-2xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-black text-black mb-1 group-hover:text-primary transition-colors">Building Ideas & Capability</h3>
                  <p className="text-sm text-gray-500 font-medium leading-relaxed">Equipping teams with the mindset, tools and confidence to innovate and grow.</p>
                </div>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-line text-primary text-lg"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Case Studies */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-end justify-between mb-14">
            <h2 className="text-6xl lg:text-7xl font-black text-black tracking-tight">Work</h2>
            <Link to="/work" className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-primary hover:gap-3 transition-all duration-200 whitespace-nowrap group">
              View All Work
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>

          <CaseStudyCarousel />
        </div>
      </section>

      {/* Why Design For Section */}
      <section className="pt-20 pb-28 bg-[#f8f8f8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
            <h2 className="text-6xl lg:text-7xl font-black text-black tracking-tight">Why Design For</h2>
            <Link to="/about" className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-primary hover:gap-3 transition-all duration-200 whitespace-nowrap group">
              Learn More About Us
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>

          <div className="space-y-4">
            <div className="bg-white rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-all duration-300">
              <div className="flex flex-col lg:flex-row gap-5 lg:gap-8 items-start">
                <p className="text-2xl font-black text-primary flex-shrink-0">01</p>
                <div className="space-y-2">
                  <h3 className="text-xl font-black text-black leading-tight">
                    Energy, empathy and alignment that moves organisations forward
                  </h3>
                  <p className="text-base text-gray-500 leading-relaxed font-medium">
                    Design For builds trust quickly across cultures, functions and seniority levels. With experience spanning 40+ countries, we unite diverse stakeholders, create clarity in complexity, and generate the momentum that turns strategy into action.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-all duration-300">
              <div className="flex flex-col lg:flex-row gap-5 lg:gap-8 items-start">
                <p className="text-2xl font-black text-primary flex-shrink-0">02</p>
                <div className="space-y-2">
                  <h3 className="text-xl font-black text-black leading-tight">
                    Commercial outcomes designed in from day one
                  </h3>
                  <p className="text-base text-gray-500 leading-relaxed font-medium">
                    Human-centred design isn&apos;t a feel-good exercise. It sharpens strategy, strengthens value propositions, improves customer loyalty and drives measurable growth. Insight becomes performance.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-all duration-300">
              <div className="flex flex-col lg:flex-row gap-5 lg:gap-8 items-start">
                <p className="text-2xl font-black text-primary flex-shrink-0">03</p>
                <div className="space-y-2">
                  <h3 className="text-xl font-black text-black leading-tight">
                    Confidence in complex, high-stakes environments
                  </h3>
                  <p className="text-base text-gray-500 leading-relaxed font-medium">
                    From highly regulated healthcare to global systems change, Design For brings structured thinking, calm leadership and cultural intelligence where stakes are high and decisions matter.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-all duration-300">
              <div className="flex flex-col lg:flex-row gap-5 lg:gap-8 items-start">
                <p className="text-2xl font-black text-primary flex-shrink-0">04</p>
                <div className="space-y-2">
                  <h3 className="text-xl font-black text-black leading-tight">
                    Strategy that lands and sticks
                  </h3>
                  <p className="text-base text-gray-500 leading-relaxed font-medium">
                    From future vision and business models to research, prototyping and delivery roadmaps, Design For works across the full arc, blending digital pace with consulting rigour so ideas are bold and executable.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-all duration-300">
              <div className="flex flex-col lg:flex-row gap-5 lg:gap-8 items-start">
                <p className="text-2xl font-black text-primary flex-shrink-0">05</p>
                <div className="space-y-2">
                  <h3 className="text-xl font-black text-black leading-tight">
                    Designing for impact beyond the balance sheet
                  </h3>
                  <p className="text-base text-gray-500 leading-relaxed font-medium">
                    The strongest businesses create value for customers, communities and society. Design For believes that when you design properly for people, commercial success and positive impact move together. Growth and good are not competing forces, they reinforce each other.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <h2 className="text-6xl lg:text-7xl font-black text-black tracking-tight mb-20 text-center">Clients</h2>
          
          <div className="flex items-center justify-center gap-16 flex-wrap">
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/cd7ce9f69a03d3f4d33dd2bc161a2130.png" 
                alt="AstraZeneca" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/2c1ed308982a55bdfbbaceba3250b5c3.svg" 
                alt="Pfizer" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/b74ebfb7097f88dc05c90f897e32bab6.png" 
                alt="World Health Organization" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-20 w-56">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/c4b5194fe84ce413cb2d4f51b8867f6d.png" 
                alt="Australian Government Department of Human Services" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/b1a8515de99cee5a78785dc6ac1077dc.png" 
                alt="World Vision" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/71ae5d6c5e52b4997b103b678f71b786.png" 
                alt="Adobe" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/ef82b5879b44834c4975bd6bac2a90ab.png" 
                alt="Google" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/15bfbda413a32015f8f06c56c43fe01e.png" 
                alt="Jetstar" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/a4a57f68e69ec4d1bee7f43d2f933a83.png" 
                alt="L'Oréal" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-20 w-56">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/d5545702884017514c836695c94d369e.png" 
                alt="Merlin Entertainments" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/119a4bb015b9c96f9e524730e4c6d326.png" 
                alt="Dulux" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
            <div className="flex items-center justify-center h-16 w-48">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/20430f2d0a70368737cc33ffe7ffdf65.png" 
                alt="ANZ" 
                className="max-w-full max-h-full object-contain grayscale"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-32 relative overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/3228d749d32dbfef0cbba4c77441ff6d.jpeg"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-6xl lg:text-7xl font-black text-white tracking-tight mb-8">Contact&nbsp;</h2>
          <p className="text-xl text-white/90 mb-12 font-medium">Let's discuss how we can design a better future together.</p>
          <Link to="/contact" className="bg-white text-primary px-12 py-6 rounded-full hover:bg-white/90 transition-all duration-300 text-lg font-bold uppercase tracking-wider inline-flex items-center gap-3 whitespace-nowrap">
            Get In Touch
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-3 gap-12 mb-16">
            <div className="space-y-6">
              <img 
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/177dc540d7c9a6700435609d623348f7.png" 
                alt="Design For" 
                className="h-16"
              />
              <p className="text-white/60 text-sm leading-relaxed">Strategic consulting for ambitious businesses.</p>
            </div>

            <div>
              <h4 className="text-sm uppercase tracking-wider text-white font-bold mb-6">Navigate</h4>
              <div className="space-y-3">
                <Link to="/" className="block text-white/70 hover:text-primary transition-colors text-sm font-medium">Home</Link>
                <Link to="/about" className="block text-white/70 hover:text-primary transition-colors text-sm font-medium">About</Link>
                <Link to="/services" className="block text-white/70 hover:text-primary transition-colors text-sm font-medium">Services</Link>
                <Link to="/work" className="block text-white/70 hover:text-primary transition-colors text-sm font-medium">Work</Link>
                <Link to="/resources" className="block text-white/70 hover:text-[#ff4858] transition-colors text-sm font-medium">Insights</Link>
                <Link to="/contact" className="block text-white/70 hover:text-primary transition-colors text-sm font-medium">Contact</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm uppercase tracking-wider text-white font-bold mb-6">Follow</h4>
              <div className="flex gap-4">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-primary rounded-full flex items-center justify-center transition-colors">
                  <i className="ri-linkedin-fill text-white text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/40 font-medium">© 2026 Design For Consulting</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-white/40 hover:text-primary transition-colors text-sm font-medium">Privacy</Link>
              <Link to="/terms" className="text-white/40 hover:text-primary transition-colors text-sm font-medium">Terms</Link>
              <Link to="/cookies" className="text-white/40 hover:text-primary transition-colors text-sm font-medium">Cookies</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}